export const onlineFileExists = async (url: string) => {
  try {
    const response = await fetch(url, { method: "HEAD" });
    return response.ok;
  } catch {
    // console.error("Error fetching the URL:", error);
    return false;
  }
};
